import { ListItemIcon, MenuItem, Typography } from "@mui/material";
import { ReactComponent as LogOutIcon } from "../../../common/icons/logout.svg";

type Props = {
  label: string;
  onClick: () => void;
};

const LogOut = ({ label, onClick }: Props) => (
  <MenuItem data-testid="toolbar-menu-logout-button" onClick={onClick}>
    <ListItemIcon>
      <LogOutIcon />
    </ListItemIcon>
    <Typography variant="header" fontWeight="600">
      {label}
    </Typography>
  </MenuItem>
);

export default LogOut;
